import React from "react";

import {
  FaArrowDown,
  FaArrowRight,
  FaClock,
  FaExpand,
  FaPlay,
  FaStopwatch,
  FaTabletAlt,
  FaTrophy,
} from "react-icons/fa";

import ScoreButton from "../ui/ScoreButton";

export default function ScoreHero({
  onOpenScoreboard,
  onDiscover,
}) {
  return (
    <section className="relative isolate overflow-hidden bg-slate-950">
      {/* Décors */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_15%_20%,rgba(249,115,22,0.22),transparent_30%),radial-gradient(circle_at_85%_35%,rgba(0,75,134,0.34),transparent_34%)]" />

      <div className="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,0.035)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.035)_1px,transparent_1px)] bg-[size:42px_42px]" />

      <div className="absolute -left-20 top-32 h-72 w-72 rounded-full bg-orange-500/15 blur-3xl" />

      <div className="absolute -right-20 bottom-0 h-96 w-96 rounded-full bg-blue-500/15 blur-3xl" />

      <div className="relative mx-auto grid min-h-[760px] max-w-7xl items-center gap-14 px-4 pb-24 pt-32 sm:px-6 lg:grid-cols-[0.9fr_1.1fr] lg:px-8">
        {/* Texte */}
        <div className="relative z-10">
          <div className="inline-flex items-center gap-2 rounded-full border border-orange-300/20 bg-orange-400/10 px-4 py-2 text-xs font-black uppercase tracking-[0.18em] text-orange-300 backdrop-blur">
            <FaStopwatch />

            Tableau de score gratuit
          </div>

          <h1 className="mt-7 text-5xl font-black leading-[0.92] tracking-tight text-white sm:text-6xl lg:text-7xl xl:text-8xl">
            Mon
            <span className="bg-gradient-to-r from-amber-300 via-orange-400 to-orange-600 bg-clip-text text-transparent">
              Appli
            </span>
            Score
          </h1>

          <p className="mt-7 max-w-2xl text-lg leading-8 text-slate-200 sm:text-xl">
            Le tableau de score de judo
            simple, complet et accessible
            gratuitement depuis votre
            navigateur.
          </p>

          <p className="mt-4 max-w-2xl text-sm leading-7 text-slate-400 sm:text-base">
            Chronomètre de combat, Golden
            Score, Ippon, Waza-ari, Yuko,
            Shido, Osaekomi et affichage
            plein écran : tout ce dont vous
            avez besoin pour vos cours,
            stages et animations.
          </p>

          <div className="mt-9 flex flex-col gap-3 sm:flex-row sm:items-center">
            <ScoreButton
              icon={FaArrowRight}
              onClick={
                onOpenScoreboard
              }
            >
              Ouvrir le tableau
            </ScoreButton>

            <ScoreButton
              icon={FaArrowDown}
              variant="secondary"
              onClick={onDiscover}
            >
              Découvrir les fonctions
            </ScoreButton>
          </div>

          <div className="mt-10 grid max-w-2xl gap-3 sm:grid-cols-3">
            <HeroBenefit
              icon={FaPlay}
              title="Accès immédiat"
              text="Sans création de compétition"
            />

            <HeroBenefit
              icon={FaTabletAlt}
              title="Multi-écrans"
              text="Ordinateur, tablette ou TV"
            />

            <HeroBenefit
              icon={FaTrophy}
              title="100 % judo"
              text="Scores et règles adaptés"
            />
          </div>
        </div>

        {/* Visuel */}
        <div className="relative">
          <div className="absolute -inset-8 rounded-full bg-blue-500/15 blur-3xl" />

          <div className="relative rounded-[2rem] border border-white/15 bg-white/10 p-2 shadow-2xl shadow-black/50 backdrop-blur">
            <div className="overflow-hidden rounded-[1.6rem] border border-white/10 bg-black">
              <div className="flex items-center justify-between border-b border-white/10 bg-slate-950 px-4 py-3">
                <div className="flex items-center gap-2">
                  <span className="h-2.5 w-2.5 rounded-full bg-red-500" />
                  <span className="h-2.5 w-2.5 rounded-full bg-amber-400" />
                  <span className="h-2.5 w-2.5 rounded-full bg-emerald-500" />
                </div>

                <span className="text-[10px] font-black uppercase tracking-[0.2em] text-slate-500">
                  MonAppliScore
                </span>
              </div>

              <img
                src="/images/appli/monappliscore.png"
                alt="Aperçu de MonAppliScore, tableau de score de judo"
                className="aspect-[16/10] w-full bg-black object-contain object-center"
                loading="eager"
              />
            </div>
          </div>

          <div className="absolute -left-4 top-10 rounded-2xl border border-white/15 bg-slate-950/90 px-4 py-3 text-white shadow-xl backdrop-blur sm:-left-8">
            <div className="flex items-center gap-3">
              <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-orange-500 text-white">
                <FaClock />
              </div>

              <div>
                <p className="text-xs font-black">
                  Chronomètre
                </p>

                <p className="text-[11px] text-slate-400">
                  Combat et Golden Score
                </p>
              </div>
            </div>
          </div>

          <div className="absolute -bottom-6 right-3 rounded-2xl border border-white/15 bg-white px-4 py-3 text-slate-950 shadow-2xl sm:-right-6">
            <div className="flex items-center gap-3">
              <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-[#004b86] text-white">
                <FaExpand />
              </div>

              <div>
                <p className="text-xs font-black">
                  Mode plein écran
                </p>

                <p className="text-[11px] text-slate-500">
                  Idéal sur TV ou vidéoprojecteur
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-slate-50 to-transparent dark:from-slate-950" />
    </section>
  );
}

function HeroBenefit({
  icon: Icon,
  title,
  text,
}) {
  return (
    <article className="rounded-2xl border border-white/10 bg-white/[0.07] p-4 backdrop-blur">
      <Icon className="text-xl text-orange-300" />

      <p className="mt-3 text-sm font-black text-white">
        {title}
      </p>

      <p className="mt-1 text-xs leading-5 text-slate-400">
        {text}
      </p>
    </article>
  );
}